const state = {
  user: null,
};

// getters
const getters = {
  user: currentState => currentState.user,
  signedIn: currentState => currentState.user != null,
};

// actions
const actions = {
  setUser({ commit }, user) {
    commit('setUser', user);
  },
};

// mutations
const mutations = {
  setUser(currentState, user) {
    currentState.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js